import React from 'react';
import { Link } from "react-router-dom";
import { BsPencilSquare } from "react-icons/bs";
import moment from 'moment';

function CotizacionItem({datos}) {

    const valorNumero = (numero) => new Intl.NumberFormat().format(numero);

    const fechaValor = datos.fechaValor
        ? moment(datos.fechaValor).format('DD/MM/YYYY')
        : '-';

    return (
        <tr className='table__tr'>
            <td>{datos.nombre}</td>
            <td>{datos.descripcion ? datos.descripcion : '-'}</td>
            <td>{datos.claveUnica}</td>
            <td>${valorNumero(datos.valorActual)}</td>
            <td>{fechaValor}</td>
            <td>{datos.vecesUsado}</td>
            <td>{datos.activo ? 'Activo' : 'Inactivo'}</td>
            <td>
                <div className='table__opciones'>
                    <Link to={`editar/${datos.id}`}>
                        <button type='button' className="btn btn-warning">
                            <BsPencilSquare size={23} color="#ffff"/>
                        </button>
                    </Link>
                </div>
            </td>
        </tr>
    )
}

export default CotizacionItem
